// extracted by mini-css-extract-plugin
export default {"photoHeartWrapper":"_4847abf4","heartIcon":"_96d9e0e0 _ff04910a","photoLikesCountWrapper":"_128caca5","iconWrapper":"_cb758159 _ba6c7799","withTotalLikes":"_8b82aad9"};